import { FormControl, FormField, FormItem, FormLabel, FormDescription, FormMessage } from '@/components/ui/form';
import { Control, FieldValues, Path, useFormContext } from 'react-hook-form';
import { cn } from '@/lib/utils';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import React from 'react';


interface RadioGroupFieldProps<T extends FieldValues> {
  name: Path<T>;
  label: string | React.ReactNode;
  control: Control<T>;
  options: { [key: string]: string };
}

export const RadioGroupField = <T extends FieldValues>({ name, label, control, options }: RadioGroupFieldProps<T>) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="font-semibold text-base">{label}</FormLabel>
          <FormControl>
            <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                className='flex flex-col space-y-0'
            >
                {Object.entries(options).map(([value, optionLabel]) => (
                    <FormItem key={value} className="flex items-center space-x-3 space-y-0">
                        <FormControl
                            className={cn(errors?.[name] ? 'border-chilli  focus:ring-chilli' : 'border-2 border-input  focus:ring-deep-blue',
                                'focus:ring-1 focus:ring-offset-0 text-left text-base',
                                !field.value && 'text-muted-foreground',
                        )}>
                            <RadioGroupItem value={value} />
                        </FormControl>
                        <FormLabel className='text-base'>
                            {optionLabel}
                        </FormLabel>
                    </FormItem>
                ))}
            </RadioGroup>
          </FormControl>
          <FormDescription className="hidden" />
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
